<template>
	<div v-if="visible">
		<div :class="['app-toast-message', { 'app-toast-message--success': isSuccess, 'app-toast-message--error': isError, 'app-toast-message--info': isInfo  }]">
			<div class="app-toast-message-icon"></div>
			<div class="app-toast-message-message">
				<div class="app-toast-message-message-title">{{ params.title }}</div>
				<div class="app-toast-message-message-msg">{{ params.message }}</div>
			</div>
			<div class="app-toast-message-close"><button class="app-toast-message-close-button" @click="hide"></button></div>
		</div>
	</div>
</template>

<script>
import { setTimeout, clearTimeout } from 'timers';
export default {
	name: 'toast-message',
	data() {
		return {
			visible: false,
			timeout: 0,
			timeoutHanlder: null
		}
	},
	props: {
		params: Object
	},
	methods: {
		hide() {
			if (this.timeoutHanlder) {
				clearTimeout(this.timeoutHanlder)
				this.timeoutHanlder = null
			}
			this.visible = false;
			this.$emit('hide', this.params)
		},
		confirm() {
			if(typeof this.onConfirm === 'function') {al
				this.onConfirm()
			}
			this.hide()
		},
		show() {
			this.visible = true
			if (this.timeout > 0) {
				this.timeoutHanlder = setTimeout(() => {
					this.hide()
				}, this.timeout)
			}
		}
	},
	computed: {
		isSuccess() {
			return this.params.type === 'success'
		},
		isError() {
			return this.params.type === 'error'
		},
		isInfo() {
			return this.params.type === 'info'
		}
	},
	mounted() {
		this.timeout = this.params.timeout || 0
		this.show()
	}
}
</script>

<style scoped>
.app-toast-message {
	margin: 10px 10px 0 10px;
	padding: 10px 5px;
	border-radius: 2px;
	box-shadow: rgba(0,0,0,0.25) 0 0 5px;
	background-color: #fbfafd;
	display: grid;
	grid-template-columns: 35px auto 40px;
	align-items: center;
	justify-items: center;
	border-left: #ffc123 solid 4px;
}
.app-toast-message-icon {
	width: 24px;
	height: 24px;
	background-color: #ffc123;
	background-image: url(/static/svg/alerts/danger.svg);
	background-size: 12px;
	background-position: center;
	background-repeat: no-repeat;
	border-radius: 100%;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 700;
	font-size: 12px;
}
.app-toast-message-message {
	padding: 0 10px;
	justify-self: flex-start;
}
.app-toast-message-message-title {
	font-size: 14px;
	font-weight: 700;
	margin: 0 0 5px 0;
}
.app-toast-message-message-msg {
	font-size: 14px;
	color: #555;
}
.app-toast-message-close-button {
	width: 30px;
	height: 30px;
	border-radius: 100%;
	color: #000;
	border: 0;
	background-color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	background-image: url(/static/svg/alerts/close.svg);
	background-size: 12px;
	background-position: center;
	background-repeat: no-repeat;
	outline: none;
}
.app-toast-message-close-button:hover,
.app-toast-message-close-button:active {
	background-color: rgba(0,0,0,0.25);
}
.app-toast-message.app-toast-message--success {
	border-left: #8bc34a solid 4px;
}
.app-toast-message.app-toast-message--success .app-toast-message-icon {
	background-color: #8bc34a;
	background-image: url(/static/svg/alerts/check.svg);
}
.app-toast-message.app-toast-message--error {
	border-left: #f44336 solid 4px;
}
.app-toast-message.app-toast-message--error .app-toast-message-icon {
	background-color: #f44336;
	background-image: url(/static/svg/alerts/cancel.svg);
}
.app-toast-message.app-toast-message--info {
	border-left: #03a9f4 solid 4px;
}
.app-toast-message.app-toast-message--info .app-toast-message-icon {
	background-color: #03a9f4;
	background-image: url(/static/svg/alerts/information.svg);
}
</style>


// WEBPACK FOOTER //
// src/components/alerts/ToastMessage.vue